import Vue from 'vue';
import Home from './Home.vue';
import VueBootstrap from 'bootstrap-vue';
import FlagIcon from 'vue-flag-icon';
import VModal from 'vue-js-modal';

import i18n from '@/plugins/i18n';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faFacebookF, faTwitter, faInstagram, faEnvelope);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(VueBootstrap);
Vue.use(FlagIcon);
Vue.use(VModal, { dynamic : true, dialog: true });

Vue.config.productionTip = false;

new Vue({
	i18n,
	render: (h) => h(Home)
}).$mount('#home');
